<template>
  <div>
    <!-- 大状态 -->
    <div class="status-step">
      <el-steps :active="activeIndex" finish-status="success" align-center>
        <el-step v-for="status in orderStatusList" :key="status.key" :title="status.value"
          @click.native="showSubStep(status.key)" />
      </el-steps>
      <el-button v-if="canShowRecord" class="btn-red btn-record" size="small"
        :class="{ 'btn-perfect-more': tradeApplyExecPerfectVOList }" @click="handleRecord">查看每次执行进度
      </el-button>
    </div>

    <!-- 子状态 -->
    <div class="sub-status-step" v-if="subStepShow">
      <div class="step">
        <!-- 非堆箱订单 -->
        <div class="steps-row" v-if="!isTrack">
          <div v-for="(item, index) in subOrderStatusList" :key="index" :class="{ actived: item.node === subStatus }"
            class="step-pointer">
            <i class="el-icon-check"></i>
            <i class="el-icon-arrow-right" v-if="item.node === subStatus"></i>
            <div class="step-role">{{ item.employeeLevelName || '' }}</div>
            <div class="step-name">{{ item.processClientName || '' }}</div>
            <div class="step-status">
              <div style="position: relative">
                {{ formatStatusName(item.nodeName) || '' }}
                <span v-if="item.node === '430' && bpmBtnShow" class="step-status__bpm" @click="handlePrimeStatus">
                  查看进度>
                </span>
                <!-- <span v-if="item.node === '430' && primeBtnShow" class="step-status__bpm" @click="handlePrimeStatus">
                  查看进度>
                </span> -->
                <span v-if="item.node == '340' && isShowCoolerBtn" class="step-status__wys" @click="queryLogisticsTrack">查看物流详情</span>
              </div>
              <div v-if="item.node === subStatus && tradeApplyOrderVO.waitTimeDesc" class="step-stay__time">
                (已停留：{{ tradeApplyOrderVO.waitTimeDesc }})
              </div>
            </div>
          </div>
        </div>

        <!-- 堆箱订单 -->
        <div class="steps-row" v-if="isTrack && !tradeApplyExecPerfectVOList && orderType !== '109'">
          <div v-for="(item, index) in subOrderStatusList" :key="index" :class="{ actived: item.node === subStatus }"
            class="step-pointer">
            <div class="step-btn" v-if="item.planWeekStatus !== 0 && item.planWeekStatus !== 90">
              <el-button class="btn-red" size="small" @click="showPic(item, 'img')">查看堆箱照片</el-button>
            </div>
            <div class="step-name-stack">{{ subOrderStatusList[0].applyPerson || 'CIRCLE' }}</div>
            <div class="step-status">
              <div class="step-status-text">
                <div class="step-status-week">{{ `第${item.planWeek}周` }}</div>
                <div class="step-status-status"
                  @click="showPic(tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList, 'status')">{{
                    item.planWeekStatusName || '' }} ></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 完美门店 -->
        <div class="steps-row" v-if="isTrack && tradeApplyExecPerfectVOList">
          <div class="step-pointer" v-for="(item, index) in subOrderStatusList" :key="index"
            :class="{ actived: item.node === subStatus }">
            <div class="step-btn" v-if="item.planWeekStatus !== 0 && item.planWeekStatus !== 90">
              <el-button class="btn-red" size="small" @click="showPic(item, 'perfect')" v-if="item.trackStatus !== 0
                && item.trackStatus !== 10
                && item.trackStatus !== 90">查看执行照片</el-button>
            </div>
            <div class="step-name-stack" v-if="item.weekStatusList && item.weekStatusList.length">
              {{ item.weekStatusList[0].createUserName || '' }}
            </div>
            <div class="step-status">
              <div class="step-status-text">
                <div class="step-status-week">
                  {{ `第${item.planWeek}次` }}
                </div>
                <!-- @click="showPic(subOrderStatusList, 'perfectStatus', index)"> -->

                <div class="step-status-status">
                  {{ item.trackStatusName || '' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 青柠 -->
        <div class="steps-row" v-else-if="isLimes && orderType === '109'">
          <div class="step-pointer" v-for="(item, index) in subOrderStatusList" :key="index"
            :class="{ actived: item.node === subStatus }">
            <div class="step-btn">
              <el-button class="btn-red" size="small" @click="showPic(item, 'lemon')" v-if="item.trackStatus !== 0
                && item.trackStatus !== 10
                && item.trackStatus !== 90">查看执行照片
              </el-button>
            </div>
            <div class="step-name-stack">
              {{ item.createUserId || '' }}
            </div>
            <div class="step-status">
              <div class="step-status-text">
                <div class="step-status-week">
                  {{ `第${item.planWeekName}周` }}
                </div>
                <div class="step-status-status">
                  {{ item.trackStatusName || '' }} >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 弹窗 - 堆箱照片 -->
        <OrderStepInfoDialog ref="infoDialog" :isPerfect="isPerfect" />

        <!-- 弹窗 - 堆箱每周执行进度 -->
        <StackRecordDialog ref="recordDialog" />
        <OrderBpmStatusDialog ref="orderBpmStatusDialog" />
        <!-- 物流详情 -->
        <LogisticsTrackDialog ref="logisticsTrackDialog"/>
        <!-- prime审批进度 -->
        <OrderPrimeStatusDialog ref="OrderPrimeStatusDialog" />

      </div>
    </div>
  </div>
</template>

<script>
import OrderStepInfoDialog from "./order-step-info-dialog"
import StackRecordDialog from "./stack-record-dialog"
import OrderBpmStatusDialog from './order-bpm-status-dialog'
import LogisticsTrackDialog from './logistics-track-dialing'
import OrderPrimeStatusDialog from "./order-prime-status-dialog"
import { commonUtils } from "../../../utils/common"
import tradeApplySuccessVue from '../trade-apply-success.vue'

export default {
  name: "order-step-info",
  components: {
    OrderStepInfoDialog,
    StackRecordDialog,
    OrderBpmStatusDialog,
    LogisticsTrackDialog,
    OrderPrimeStatusDialog
  },
  props: {
    isPerfect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tradeApplyOrderVO: "",
      tradeApplyInfoVO: "",
      tradeApplyProcessRecordVO: "",
      tradeApplyExecPerfectVOList: null,
      activeIndex: 2,
      orderStatusList: [],
      subOrderStatusList: [],
      statusNodeList: [],
      orderType: "",
      subStatus: "",
      subStepShow: false,
      isTrack: false,
      isLimes: false,
      trackRecordList: [],
      channelCode: "",
      canShowRecord: false,
      tradePerfectTrackRecordList: []
    };
  },
  created() { },
  computed: {
    bpmBtnShow() {
      if (this.tradeApplyOrderVO) {
        const { tradeApplyInfoVO } = this.tradeApplyOrderVO
        return Number(tradeApplyInfoVO.applyStatus) > 300 && Number(tradeApplyInfoVO.acceptanceStatus) === 430
      }
      return false
    },
    // primeBtnShow(){
    //   if (this.tradeApplyOrderVO) {
    //     const { tradeApplyInfoVO , applyType } = this.tradeApplyOrderVO
    //     return applyType === '02' && Number(tradeApplyInfoVO.applyStatus) > 300 && Number(tradeApplyInfoVO.acceptanceStatus) > 420
    //   }
    //   return false
    // },
    isShowCoolerBtn() {
      if(this.tradeApplyOrderVO.tradeApplyExecCooler && this.tradeApplyOrderVO.tradeApplyExecCooler.execTypeSub === '102'){
        const { tradeApplyInfoVO } = this.tradeApplyOrderVO
        return Number(tradeApplyInfoVO.applyStatus) >= 300 && Number(tradeApplyInfoVO.executionStatus) >= 340
      }
      return false
    },

    isShowCoolerBtn() {
      if(this.tradeApplyOrderVO.tradeApplyExecCooler && this.tradeApplyOrderVO.tradeApplyExecCooler.execTypeSub === '102'){
        const { tradeApplyInfoVO } = this.tradeApplyOrderVO
        return Number(tradeApplyInfoVO.applyStatus) >= 300 && Number(tradeApplyInfoVO.executionStatus) >= 340
      }
    }
  },
  created() { },
  methods: {
    // 订单类型设置status list
    // 01-高端店招、物料定制；02-资产冰柜；03-堆箱；04-批量化物料；05-ISP高端执行；06-ISP形象店；07-ISP物料定制；09-物料定制；10-KA物料定制；11-KA批量化物料；12-isp批量化物料；13-butp百威批量化物料; 14-pbo
    setOrderStatusList(val) {
      this.tradeApplyOrderVO = val
      this.tradeApplyInfoVO = this.tradeApplyOrderVO.tradeApplyInfoVO
      this.channelCode = this.tradeApplyInfoVO.channelCode
      this.tradeApplyProcessRecordVO = this.tradeApplyOrderVO.tradeApplyProcessRecordVO
      this.tradeApplyExecPerfectVOList = this.tradeApplyOrderVO.tradeApplyExecPerfectVOList

      // 批量化物料
      if (this.tradeApplyOrderVO.applyType === "02") {
        if (this.tradeApplyInfoVO.clientType === "01") {
          if (this.tradeApplyInfoVO.applyClientLevel === 60) {
            this.orderType = "13";
          } else {
            this.orderType = "04";
          }
        } else if (this.tradeApplyInfoVO.clientType === "03") {
          this.orderType = "11";
        } else if (this.tradeApplyInfoVO.clientType === "02") {
          this.orderType = "12";
        }
      } else if (this.tradeApplyOrderVO.applyType === "03") {
        // ISP
        if (this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub === "301") {
          this.orderType = "05";
        } else if (
          this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub === "302"
        ) {
          this.orderType = "06";
        } else if (
          this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub === "303"
        ) {
          this.orderType = "07";
        }
      } else if (this.tradeApplyOrderVO.applyType === "04") {
        // pbo
        this.orderType = "104";
      } else {
        // 堆箱
        if (this.tradeApplyOrderVO.tradeApplyExecStack) {
          this.orderType = "03";
        } else if (
          this.tradeApplyOrderVO.tradeApplyExecCooler &&
          !this.tradeApplyOrderVO.tradeApplyExecCustom
        ) {
          // 资产冰柜
          this.orderType = "02";
        } else if (
          !this.tradeApplyOrderVO.tradeApplyExecVO &&
          this.tradeApplyOrderVO.tradeApplyExecCustom
        ) {
          // 物料定制
          if (this.tradeApplyInfoVO.clientType === "01") {
            this.orderType = "09";
          } else if (this.tradeApplyInfoVO.clientType === "03") {
            this.orderType = "10";
          }
        } else if (this.tradeApplyExecPerfectVOList) {
          this.orderType = "105";
        } else if (
          this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "107" ||
          this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "108"
        ) {
          this.orderType = "107";
        } else if (
          this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "111" ||
          this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "112" ||
          this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "113"
        ) {
          this.orderType = this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub
        } else if (this.tradeApplyOrderVO.tradeApplyExecVO && this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub === '109') {
          this.orderType = '109'
        } else if (this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "202") {
          this.orderType = '202'
        } else {
          this.orderType = "01";
        }
      }

      // 设置状态节点
      if (this.orderType === '01' || this.orderType === '05' || this.orderType === '06' || this.orderType === '07' || this.orderType === '09' || this.orderType === '10' || this.orderType === '11' || this.orderType === '202') {
        this.orderStatusList = this.$store.state.trade.stepListExec
      } else if (this.orderType === '02') {
        this.orderStatusList = this.$store.state.trade.stepListCooler
      } else if (this.orderType === '03') {
        if (this.tradeApplyOrderVO.tradeApplyExecStack.tradeApplyExecStackDTO.stackSpecs === '02') {
          this.orderStatusList = this.$store.state.trade.stepListStacks
        } else {
          this.orderStatusList = this.$store.state.trade.stepListStack
        }
      } else if (this.orderType === '04' || this.orderType === '13') {
        this.orderStatusList = this.$store.state.trade.stepListBulk
      } else if (this.orderType === '12' || this.orderType === '11') {
        if (this.tradeApplyInfoVO.applyClientLevel === 50) {
          this.orderStatusList = this.$store.state.trade.stepListExec
        } else {
          this.orderStatusList = this.$store.state.trade.stepListBulk
        }
      } else if (this.orderType === '104') {
        this.orderStatusList = this.$store.state.trade.stepListPbo
      } else if (this.orderType === '105') {
        this.orderStatusList = this.$store.state.trade.stepListPerfect
      } else if (this.orderType === '107') {
        this.orderStatusList = this.$store.state.trade.stepListEnergy
      }

      // 设置step当前的节点
      this.orderStatusList.forEach((item, index) => {
        if (
          this.tradeApplyInfoVO.applyType === "04" &&
          this.tradeApplyInfoVO.applyStatus === "300"
        ) {
          this.activeIndex = 3;
          return;
        }
        if (this.tradeApplyInfoVO.applyStatus === "500") {
          this.activeIndex = this.orderStatusList.length;
        } else if (item.key === this.tradeApplyInfoVO.applyStatus) {
          this.activeIndex = index;
        }
      });
      // 获取子节点
      let pocId = "";
      if (
        this.tradeApplyOrderVO.applyType === "01" ||
        this.tradeApplyOrderVO.applyType === "03"
      ) {
        pocId = this.tradeApplyOrderVO.tradeApplyBaseVO.pocId;
      } else {
        pocId = "";
      }
      let params = {
        type: this.orderType,
        pocId: pocId,
        applyNumber: this.tradeApplyInfoVO.applyNumber
      }
      this.$store.dispatch('getSubSteps', params).then(res => {
        if (res.data.resultCode === '0') {
          this.statusNodeList = res.data.resultData.orderStatusNodeList || []
          if (['109', '111', '112', '113'].includes(this.orderType)) {
            this.orderStatusList = this.statusNodeList.map(item => {
              return {
                key: item.node,
                value: item.nodeName
              }
            })
            // 设置step当前的节点
            this.orderStatusList.forEach((item, index) => {
              if (this.tradeApplyInfoVO.applyType === '04' && this.tradeApplyInfoVO.applyStatus === '300') {
                this.activeIndex = 3
                return
              }
              if (this.tradeApplyInfoVO.applyStatus === 'isDealStr00') {
                this.activeIndex = this.orderStatusList.length
              } else if (item.key === this.tradeApplyInfoVO.applyStatus) {
                this.activeIndex = index
              }
            })
          }

          this.showSubStep(this.tradeApplyInfoVO.applyStatus)
        }
      });
      // 是否可以显示执行进度按钮
      if (this.tradeApplyOrderVO.tradeApplyExecStack) {
        if (
          this.channelCode === "TT" &&
          this.tradeApplyInfoVO.applyStatus === "500"
        ) {
          if (
            this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList
          ) {
            if (
              this.tradeApplyOrderVO.tradeApplyExecStack
                .tradeStackTrackRecordList.length
            ) {
              if (
                this.tradeApplyOrderVO.tradeApplyExecStack
                  .tradeStackTrackRecordList.length > 5
              ) {
                this.canShowRecord = true;
              }
            }
          }
        }
      }
    },

    // 展示子节点
    showSubStep(val) {
      if (
        this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "107" ||
        this.tradeApplyOrderVO.tradeApplyExecVO?.execTypeSub === "108"
      ) {
        return;
      }
      this.isLimes = false
      this.subOrderStatusList = [];

      if (Number(val) > Number(this.tradeApplyInfoVO.applyStatus)) {
        this.subStepShow = false;
        return;
      }

      if (val === "300" && this.tradeApplyExecPerfectVOList) {
        this.isTrack = true;
        if (this.tradeApplyInfoVO.applyStatus === "300") {
          if (this.tradeApplyExecPerfectVOList.length) {
            this.tradePerfectTrackRecordList = commonUtils.deepClone(
              this.tradeApplyExecPerfectVOList[0].tradePerfectTrackRecordList
            )
            if (this.tradeApplyExecPerfectVOList[0]?.tradePerfectTrackRecordList.length > 5) {
              this.canShowRecord = true
              this.tradeApplyExecPerfectVOList[0].tradePerfectTrackRecordList =
                this.tradeApplyExecPerfectVOList[0].tradePerfectTrackRecordList.slice(-5)
            }
          }
        }
        this.subOrderStatusList = this.tradeApplyExecPerfectVOList[0].tradePerfectTrackRecordList;
      } else if (this.orderType === "03" && val === "500") {
        this.isTrack = true;

        if (
          this.channelCode === "CR" &&
          this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList
        ) {
          this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList.reverse();
          this.trackRecordList = this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList;
          if (
            this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList
              .length > 5
          ) {
            this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList = this.tradeApplyOrderVO.tradeApplyExecStack.tradeStackTrackRecordList.slice(
              -5
            );
          }
        }
        this.subOrderStatusList =
          this.tradeApplyOrderVO.tradeApplyExecStack
            .tradeStackTrackRecordList || [];

        if (
          this.tradeApplyOrderVO.tradeApplyExecStack.tradeApplyExecStackDTO
            .stackSpecs === "02"
        ) {
          this.subOrderStatusList[0].applyPerson = `${this.tradeApplyInfoVO.applyClientLevelName}-${this.tradeApplyInfoVO.applyClientName}`;
        }
      } else if (this.orderType === '109' && val === '300' && this.tradeApplyOrderVO.tradeApplyExecLemonInfo) {
        this.isLimes = true
        this.isTrack = true
        if (this.tradeApplyInfoVO.applyStatus === '300') {
          if (this.tradeApplyOrderVO.tradeApplyExecLemonInfo.tradeLemonTrackRecordList.length) {
            this.tradePerfectTrackRecordList = commonUtils.deepClone(
              this.tradeApplyOrderVO.tradeApplyExecLemonInfo.tradeLemonTrackRecordList
            )
          }
        }
        this.subOrderStatusList = this.tradeApplyOrderVO.tradeApplyExecLemonInfo.tradeLemonTrackRecordList
      } else {
        // 其它订单
        if (!this.tradeApplyProcessRecordVO) {
          return;
        }
        this.isTrack = false;

        // 设置子节点
        this.statusNodeList.forEach(item => {
          if (val === item.node) {
            this.subOrderStatusList = item.subNodeList || [];
          }
        });

        if (val === "100") {
          if (this.tradeApplyProcessRecordVO.waitApproveRecordList) {
            this.subOrderStatusList.forEach((item, index) => {
              this.tradeApplyProcessRecordVO.waitApproveRecordList.forEach(
                temp => {
                  if (item.node === temp.detailStatus) {
                    this.$set(
                      item,
                      "employeeLevelName",
                      temp.employeeLevelName
                    );
                    this.$set(
                      item,
                      "processClientName",
                      temp.processClientName
                    );
                  }
                }
              );
            });
            if (val === this.tradeApplyInfoVO.applyStatus) {
              this.subStatus = this.tradeApplyInfoVO.requirementStatus;
            }
          } else {
            if (this.tradeApplyInfoVO.requirementStatus) {
              this.subStatus = this.tradeApplyInfoVO.requirementStatus;
            } else {
              this.subStatus = this.subOrderStatusList[0].node;
            }
          }
        }

        if (val === "200") {
          if (this.tradeApplyProcessRecordVO.waitConfirmRecordList) {
            this.subOrderStatusList.forEach(item => {
              this.tradeApplyProcessRecordVO.waitConfirmRecordList.forEach(
                temp => {
                  if (item.node === temp.detailStatus) {
                    this.$set(
                      item,
                      "employeeLevelName",
                      temp.employeeLevelName
                    );
                    this.$set(
                      item,
                      "processClientName",
                      temp.processClientName
                    );
                  }
                }
              );
            });
            if (val === this.tradeApplyInfoVO.applyStatus) {
              this.subStatus = this.tradeApplyInfoVO.solutionStatus;
            }
          } else {
            if (this.tradeApplyInfoVO.solutionStatus) {
              this.subStatus = this.tradeApplyInfoVO.solutionStatus;
            } else {
              this.subStatus = this.subOrderStatusList[0].node;
            }
          }
        }

        if (val === "300") {
          if (this.tradeApplyProcessRecordVO.waitConstructionRecordList) {
            this.subOrderStatusList.forEach(item => {
              this.tradeApplyProcessRecordVO.waitConstructionRecordList.forEach(
                temp => {
                  if (item.node === temp.detailStatus) {
                    this.$set(
                      item,
                      "employeeLevelName",
                      temp.employeeLevelName
                    );
                    this.$set(
                      item,
                      "processClientName",
                      temp.processClientName
                    );
                  }
                }
              );
            });
            if (val === this.tradeApplyInfoVO.applyStatus) {
              this.subStatus = this.tradeApplyInfoVO.executionStatus;
            }
          } else {
            // pbo 执行阶段无子数据
            if (this.tradeApplyInfoVO.applyType === "04") return;
            this.subStatus = this.subOrderStatusList[0].node;
          }
        }

        if (val === "400") {
          if (this.tradeApplyProcessRecordVO.waitAcceptanceRecordList) {
            this.subOrderStatusList.forEach(item => {
              this.tradeApplyProcessRecordVO.waitAcceptanceRecordList.forEach(
                temp => {
                  if (item.node === temp.detailStatus) {
                    this.$set(
                      item,
                      "employeeLevelName",
                      temp.employeeLevelName
                    );
                    this.$set(
                      item,
                      "processClientName",
                      temp.processClientName
                    );
                  }
                }
              );
            });
            if (val === this.tradeApplyInfoVO.applyStatus) {
              if (this.tradeApplyInfoVO.acceptanceStatus !== "500") {
                this.subStatus = this.tradeApplyInfoVO.acceptanceStatus;
              }
            }
          } else {
            if (this.tradeApplyInfoVO.acceptanceStatus) {
              this.subStatus = this.tradeApplyInfoVO.acceptanceStatus;
            } else {
              this.subStatus = this.subOrderStatusList[0].node;
            }
          }
        }

        // 设置当前子节点的操作人
        this.subOrderStatusList.forEach(item => {
          if (val === this.tradeApplyInfoVO.applyStatus) {
            if (val === '100') {
              if (item.node === this.tradeApplyInfoVO.requirementStatus &&
                item.node !== '105') {
                if (this.tradeApplyInfoVO.approvalClientName) {
                  this.$set(
                    item,
                    "employeeLevelName",
                    this.tradeApplyInfoVO.approvalClientLevelName
                  );
                  this.$set(
                    item,
                    "processClientName",
                    this.tradeApplyInfoVO.approvalClientName
                  );
                }
              }
            } else if (val === "200") {
              if (item.node === this.tradeApplyInfoVO.solutionStatus) {
                if (this.tradeApplyInfoVO.approvalClientName) {
                  this.$set(
                    item,
                    "employeeLevelName",
                    this.tradeApplyInfoVO.approvalClientLevelName
                  );
                  this.$set(
                    item,
                    "processClientName",
                    this.tradeApplyInfoVO.approvalClientName
                  );
                }
              }
            } else if (val === "300") {
              if (item.node === this.tradeApplyInfoVO.executionStatus) {
                if (this.tradeApplyInfoVO.approvalClientName) {
                  this.$set(
                    item,
                    "employeeLevelName",
                    this.tradeApplyInfoVO.approvalClientLevelName
                  );
                  this.$set(
                    item,
                    "processClientName",
                    this.tradeApplyInfoVO.approvalClientName
                  );
                }
              }
            } else if (val === "400") {
              if (item.node === this.tradeApplyInfoVO.acceptanceStatus) {
                if (this.tradeApplyInfoVO.approvalClientName) {
                  this.$set(
                    item,
                    "employeeLevelName",
                    this.tradeApplyInfoVO.approvalClientLevelName
                  );
                  this.$set(
                    item,
                    "processClientName",
                    this.tradeApplyInfoVO.approvalClientName
                  );
                }
              }
            }
          }
        });
      }
      if (this.subOrderStatusList.length) {
        this.subStepShow = true;
      }
    },
    // 获取物流信息
    queryLogisticsTrack(){
      this.$refs.logisticsTrackDialog.sfProgressOptionDialogShow(this.tradeApplyInfoVO.applyNumber)
    },

    // 查看堆箱打卡照片
    showPic(item, type, index) {
      this.$refs.infoDialog.showDialog(item, type, index);
    },

    // 查看打卡照片状态
    handledivDetail() { },

    formatStatusName(val) {
      if (!val) {
        return "";
      }
      let arr = val.split("");
      if (arr[0] === "待") {
        arr.splice(0, 1);
      }
      return arr.join("");
    },

    // 查看堆箱每周执行进度
    handleRecord() {
      if (this.tradeApplyExecPerfectVOList) {
        this.$refs.recordDialog.setPerfectRecordList(
          this.tradePerfectTrackRecordList
        );
      } else {
        this.$refs.recordDialog.setRecordList(this.trackRecordList);
      }
    },

    // 查看bpm进度
    handleBpmStatus() {
      this.$refs.orderBpmStatusDialog.handleDialogShow(this.tradeApplyOrderVO.applyId)
    },

    // 查看prime进度
    handlePrimeStatus(){
      const instanceKey = this.tradeApplyInfoVO.instanceKey
      if(instanceKey){
        this.$refs['OrderPrimeStatusDialog'].openDialog(instanceKey)
      }else{
        this.$message.error('缺少instanceKey')
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-step:hover {
  cursor: pointer;
}

::v-deep .el-step__head.is-process,
::v-deep .el-step__head.is-success {
  color: $base-red;
  border-color: $base-red;
}

::v-deep .el-step__title.is-process,
::v-deep .el-step__title.is-success {
  color: $base-red;
}

.status-step {
  margin-bottom: 20px;
  position: relative;
}

.btn-record {
  position: absolute;
  bottom: 0;
  right: 0;
}

.btn-perfect-more {
  right: 240px;
}

.step-status__bpm {
  color: $base-red;
  padding-left: 10px;
  cursor: pointer;
}
.step-status__wys {
  color: #409EFF;
  padding-left: 10px;
  cursor: pointer;
}

.step-stay__time {
  position: absolute;
  color: $base-red;
  font-size: 12px;
  margin-top: -10px;
  width: 400px;
}

.perfect-more {
  cursor: pointer;
  user-select: none;
  text-align: center;
  color: $base-red;
  padding-bottom: 20px;
}
</style>
